function l(r,t){return f(r,void 0,t)}function f(r,t,i){var u=i.type(t),e=u&&u.possibleLengths()||i.possibleLengths();if(!e)return "IS_POSSIBLE";var n=r.length,h=e[0];return h===n?"IS_POSSIBLE":h>n?"TOO_SHORT":e[e.length-1]<n?"TOO_LONG":e.indexOf(n,1)>=0?"IS_POSSIBLE":"INVALID_LENGTH"}

export { f as checkNumberLengthForType, l as default };
//# sourceMappingURL=contact-channels186.js.map
